exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-map {\n  width: 100%;\n  position: absolute;\n  height: 100%;\n  background-color: #e5e3df; }\n\n@media screen and (max-width: 767px) {\n  .dialog-map {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background-color: #e5e3df; } }\n\n@media screen and (max-width: 767px) and (orientation: portrait) {\n  #map.iphone {\n    height: calc(100% - 75px); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/google-map/google-map.component.scss
// module id = 897
// module chunks = 22